import { FailureNotice, useTranslate } from '@athena/ui'

/**
 * A create that never got an answer, on either tab.
 *
 * Deliberately no "Try again". Creating a practice is the one action here
 * that is not safe to repeat blind: the API has no idempotency key for it, so
 * if the first request did reach the server and only the answer was lost, a
 * second one makes a second practice. The title says exactly what is known —
 * Athena could not confirm it — and the Create button is still right there,
 * with every line the tutor wrote still in place, for when they have looked.
 */
export function CreateFailure({ error }: { error: unknown }) {
  const t = useTranslate()
  return <FailureNotice title={t('practice.createUnconfirmed')} error={error} />
}
